import React from 'react';
import {
  Container,
  Col,
  Row,
  Div,
} from '../../components/grid';
import {
  Heading1,
  Paragraph,
  LinkStyled,
  Bold,
} from '../../components/typography';
import SidemenuLayout from '../../layout/DefaultLayout/Layouts/SidemenuLayout';

export default () => (
  <SidemenuLayout menuPicker="Infosider" activeSidemenu="FAQ">
    <Container white itemscope itemprop="mainEntity" itemtype="https://schema.org/Question">
      <Row block>
        <Col xs={12}>
          <Row m0 innerShadow>
            <Col xs={12} padding="40px 15px" grey>
              <Row>
                <Col xs={12} md={6} offset={{ md: 3 }}>
                  <Heading1 fontSize="18px" itemprop="name">Hvad er den perfekte temperatur for fadøl?</Heading1>
                  <hr />
                  <Paragraph>
                    <Bold>Svar:</Bold>
                  </Paragraph>
                  <Div itemscope itemprop="acceptedAnswer" itemtype="https://schema.org/Answer">
                    <Paragraph>Fadøl bør udskænkes ved ca. 8 grader.</Paragraph>
                    <Paragraph>Ved 7-8 grader bliver skummet tæt og øllets smagsstoffer fremhæves perfekt. Samtidig frigives ved udskænkningen en passende mængde kulsyre således at øllet virker blødt og let.</Paragraph>
                    <Paragraph>
                      De fleste fadølsanlæg giver helt automatisk den rette temperatur. Der er altså normalt ingen steder hvor temperaturen skal indstilles eller justeres.
                      For vandkølede tappeanlæg er det dog vigtigt at de har været tilsluttet strøm i god tid før udskænkning, mindst 2 timer.
                    </Paragraph>
                  </Div>
                  <hr />
                  <Paragraph textCenter>
                    <LinkStyled to="/faq/faq" title="Tilbage til FAQ oversigt">
                      Tilbage til FAQ oversigt
                    </LinkStyled>
                  </Paragraph>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
    </Container>
  </SidemenuLayout>
);
